import { memo } from 'react';

import { InformationByMemberLevelType, MemberCardActionProps } from '../types';
import MemberCard from './MemberCard';

interface MemberListProps extends MemberCardActionProps {
  members: User[];
  level: InformationByMemberLevelType;
}

function MemberList({ members, level, ...actionProps }: MemberListProps) {
  return (
    <>
      {members
        .filter(
          (member) =>
            member.level === level.en || (level.en === 'Author' && member.level === 'Developer')
        )
        .map((member) => (
          <MemberCard key={member.id} member={member} {...actionProps} />
        ))}
    </>
  );
}

export default memo(MemberList);
